import classNames from "classnames/bind";
import styles from "./ToggleFacet.module.scss";
import { FacetComponentProps } from "../../FacetItem";

const cx = classNames.bind(styles);

export const ToggleFacet = ({ facetDetails }: FacetComponentProps) => {
  const isStockToggle = facetDetails.label === "Show in stock items only";
  const label = isStockToggle ? "Out of stock items" : facetDetails.label;
  const isSelectedText = isStockToggle ? "Hide" : "On";
  const isNotSelectedText = isStockToggle ? "Show" : "Off";

  return (
    <>
      <span className={styles.label}>{label}</span>
      <span
        className={cx("toggle", {
          ["toggle--checked"]: facetDetails.isSelected !== "true",
        })}
        aria-hidden="true"
        data-testid="toggle-facet"
      >
        <span
          className={cx("toggle__label", {
            ["toggle__label--active"]: facetDetails.isSelected !== "true",
          })}
        >
          {isNotSelectedText}
        </span>
        <span
          className={cx("toggle__label", "toggle__label--right", {
            ["toggle__label--active"]: facetDetails.isSelected === "true",
          })}
        >
          {isSelectedText}
        </span>
      </span>
    </>
  );
};
